import { del, get, post, put } from './request'
import type { MenuVO, MenuSaveRequest } from '@/types/menu'

/**
 * Get full menu tree.
 *
 * @returns menu tree
 */
export function getMenuTree(): Promise<MenuVO[]> {
  return get<MenuVO[]>('/api/v1/menus/tree')
}

/**
 * Get menus assigned to a role.
 *
 * @param roleId role id
 * @returns list of menu ids
 */
export function getRoleMenuIds(roleId: string | number): Promise<number[]> {
  return get<number[]>(`/api/v1/menus/role/${encodeURIComponent(String(roleId))}`)
}

/**
 * Get menu tree accessible to current user.
 *
 * @returns menu tree
 */
export function getUserMenus(): Promise<MenuVO[]> {
  return get<MenuVO[]>('/api/v1/menus/user-menus')
}

/**
 * Get permission codes for current user.
 *
 * @returns list of permission codes
 */
export function getUserPermissions(): Promise<string[]> {
  return get<string[]>('/api/v1/menus/user-permissions')
}

/**
 * Get menu detail by id.
 *
 * @param id menu id
 * @returns menu detail
 */
export function getMenuDetail(id: number): Promise<MenuVO> {
  return get<MenuVO>(`/api/v1/menus/${id}`)
}

/**
 * Create a new menu.
 *
 * @param data menu data
 * @returns menu id
 */
export function createMenu(data: MenuSaveRequest): Promise<number> {
  return post<number>('/api/v1/menus', data)
}

/**
 * Update an existing menu.
 *
 * @param id menu id
 * @param data menu data
 */
export function updateMenu(id: number, data: MenuSaveRequest): Promise<void> {
  return put(`/api/v1/menus/${id}`, data)
}

/**
 * Delete a menu.
 *
 * @param id menu id
 */
export function deleteMenu(id: number): Promise<void> {
  return del(`/api/v1/menus/${id}`)
}
